import type {StartEndDateFieldType} from "components/StartEndDateFields";
import type {Message} from "pages/dashboard/types";
import type {MessagesFiltersParams} from "pages/message-report/messages/MessagesFilters";
import type {Transaction} from "pages/messaging-account/transactions/api";
import {createGetHook, createPostHook} from "services/http/hooks";

export type UnitBalance = {
  balance: number;
};

export type Revenue = {
  month: string;
  revenue: number;
  cost: number;
  gross_profit: number;
};

export type MPesaPaybillConfig = {
  paybill: string;
  account_number: string;
};

export type SupportConfig = {
  email: string;
  phone: string;
};

export type Configs = {
  support: SupportConfig;
  mpesa: MPesaPaybillConfig;
};

export type DeliverySummary = {
  status_code: number;
  count: number;
};

export type DeliverySummaryFilterParams = StartEndDateFieldType & {
  account_id?: number;
};

export const useGetMessagesQuery = createGetHook<
  Message[],
  MessagesFiltersParams
>("/messages");

export const useCreatePostSTKMutation = createPostHook<
  Transaction,
  {amount: number; phone?: string}
>("/transactions/stk");

export const useGetUnitsBalanceQuery = createGetHook<
  UnitBalance,
  {account_id?: number}
>("/units/balance");

export const useGetConfigsQuery = createGetHook<Configs>("/config");

export const useGetRevenueQuery = createGetHook<Revenue[]>("/revenue");

export const useGetMessageDeliverySummaryQuery = createGetHook<
  DeliverySummary[],
  DeliverySummaryFilterParams
>("/messages/delivery-summary");
